<template>
	<div class="tarid">
		<div class="d-flex flex-start w-100">
			<div class="mr-2 hidden-md-down">
				<span class="icon-stack icon-stack-lg">
					<i class="base base-6 icon-stack-3x opacity-100 color-primary-500"></i>
					<i class="ni ni-phone icon-stack-1x opacity-100 color-white"></i>
				</span>
			</div>
			<div class="d-flex flex-fill">
				<div class="flex-fill">
					<span class="h5">Тарифи Київстар</span>
				</div>
			</div>
		</div>
		<div class="info pt-4" v-html="article.text">

		</div>
	</div>
</template>

<script>
export default {
	name: "mobile_tarif",
	data() {
		return {
			article : {
				'text' : ""
			},
		}
	},

	created() {
		this.load_article();
	},
	methods : {
		async load_article() {
			await axios.get('/internal/display/mobile_tarif').then(({data}) => {
				this.article = data.data;
			});
		},
	}
}
</script>

<style scoped>

</style>
